import {createRef} from "react";
import DataGrid, {
    Column,
    Editing,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import format from "date-fns/format";
import autoTable from 'jspdf-autotable'
import saveAs from 'file-saver';
import {FormContainer} from "../../../../palette/Palette";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";


function VehicleTypeManagementGrid(props) {

    const {dataSource, setVisibleForm, setVisibleGrid, setDataEdit, setEdit, DataStore, setTrigger, trigger} = props
    const {companyName, idCompany} = DataStore

    const dataGridRef = createRef();
    const {enqueueSnackbar} = useSnackbar();

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 120,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 135,
                text: 'Crear tipo',
                elementAttr: {id: 'button-add-grid'},
                icon: 'fas fa-plus-circle',
                onClick: () => {
                    setVisibleForm(true)
                    setEdit(false)
                    setVisibleGrid(false)
                }
            }
        })
    }

    const onRowRemoved = async (e) => {
        const docId = e.data.docId
        await db.collection(companyName).doc(idCompany).collection('TypesVehicles').doc(docId)
            .delete().then(() => {
                NotiStackInfo('Vehículo eliminado exitosamente', 'success', enqueueSnackbar)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setTrigger(!trigger)
            });
    }

    const onRowUpdating = (e) => {
        setDataEdit(e.row.data)
        setVisibleForm(false)
        setEdit(true)
        setVisibleGrid(false)
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Tipos de vehiculos`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Tipos-vehiculos.xlsx');
            });
        });
        e.cancel = true;
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Tipos-vehículos`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Tipos-vehículos.pdf');
        });
    }

    const buttons = [
        {
            hint: 'Editar',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: onRowUpdating,
        },
        'delete'];

    return (
        <FormContainer>
            <DataGrid
                id="types-vehicles"
                ref={dataGridRef}
                dataSource={dataSource}
                keyExpr="ID"
                allowColumnReordering={true}
                showBorders={true}
                onToolbarPreparing={onToolbarPreparing}
                onRowRemoved={onRowRemoved}
                rowAlternationEnabled={true}
                noDataText={'Esperando datos'}
                onExporting={onExporting}
            >
                <SearchPanel visible={true}
                             width={240}
                             placeholder="Buscar"/>
                <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                <Sorting mode="multiple"/>
                <Paging defaultPageSize={15}/>
                <Pager
                    showPageSizeSelector={true}
                    allowedPageSizes={[5, 10, 20]}
                    showInfo={true}/>

                <Editing
                    mode="row"
                    texts={{
                        editRow: 'Editar',
                        deleteRow: 'Eliminar vehículo',
                    }}
                    useIcons={true}
                    allowUpdating={true}
                    allowDeleting={true}
                />

                <Column dataField="typeVehicle" alignment={'center'} caption={'Tipo de vehículo'}/>
                <Column dataField="description" alignment={'center'} caption={'Descripcion'} width={250}/>
                <Column dataField="numberSeats" alignment={'center'} caption={'Número de asientos'}/>
                <Column dataField="numberParcels" alignment={'center'} caption={'Número de encomiendas'}/>
                <Column dataField="valueAdded" alignment={'center'} caption={'Valor agregado'}
                        format={{type: 'currency', precision: 2}}/>
                <Column dataField="state" alignment={'center'} caption="Estado"/>
                <Column type="buttons" width={110} buttons={buttons}/>
            </DataGrid>
        </FormContainer>
    )
}

export default VehicleTypeManagementGrid